<template>
	<div :class="$style.VF__Wrapper">
		<div :class="$style.VF__Complete">
			<i class="el-icon-success" />
			<p>{{ $t('common-verify-flow.starter-success-title') }}</p>
		</div>
		<div :class="$style.VF__Cando">
			<div v-for="item in candoConfig.level1" :key="item.left" :class="$style['VF__Cando--item']">
				<div :class="$style['VF__Cando--item--left']">
					<img src="~assets/img/sm-icon/right.svg" />
					<span>{{ item.left }}</span>
				</div>
				<div :class="$style['VF__Cando--item--right']">
					{{ item.right }}
				</div>
			</div>
		</div>
		<div :class="$style.VF__Advance">
			<div>
				{{ $t('common-verify-flow.starter-success-toAdvanced-before') }}
				<el-popover
					placement="bottom"
					width="240"
					trigger="hover"
					:title="$t('common-verify-flow.starter-success-toAdvanced-center')"
					:popper-class="$style['VF__Advance--popover']"
				>
					<div :class="$style.VF__Cando">
						<div v-for="item in candoConfig.level2" :key="item" :class="$style['VF__Cando--item']">
							<div :class="$style['VF__Cando--item--left']">
								<img src="~assets/img/sm-icon/right.svg" />
								<span>{{ item }}</span>
							</div>
						</div>
					</div>
					<template #reference>
						<span>{{ $t('common-verify-flow.starter-success-toAdvanced-center') }}</span>
					</template>
				</el-popover>
				{{ locale === 'en' ? $t('common-verify-flow.starter-success-toAdvanced-after') : '' }}
			</div>
		</div>
		<div :class="$style.VF__SubmitBtn" @click="goDeposit">
			{{ $t('common-verify-flow.starter-success-continue') }}
		</div>
		<span :class="$style.VF__nextStep" v-if="requireKyc2" @click="handleNext">
			{{ $t('common-verify-flow.starter-success-next') }}
		</span>
	</div>
</template>
<script>

import messages from '../i18n';
import { axiosClient } from '~/common/js/axios';

export default {
	i18n: { messages },
	name: 'Result',
	props: {
		requireKyc2: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			submiting: false,
			hasVerify: false,
			kyc24_withdrawal_limit_low: 0.06,
			kyc24_withdrawal_limit_high: 100,
			kyc24_withdrawal_limit_low_coin: 'BTC',
			kyc24_withdrawal_limit_high_coin: 'BTC',
		};
	},
	computed: {
		locale() {
      return this.store.locale;
    },
    cid() {
      return this.store.account.cid;
    },
		
		candoConfig() {
			return {
				level1: [
					{
						left: this.$t('common-verify-flow.b6-1'),
						right: this.$t('common-verify-flow.starter-success-no-limit'),
					},
					{
						left: this.$t('common-verify-flow.b7'),
						right: `${this.kyc24_withdrawal_limit_low} ${this.kyc24_withdrawal_limit_low_coin} ${this.$t(
							'common-verify-flow.daily'
						)}`,
					},
					{
						left: this.$t('common-verify-flow.b8'),
						right: this.$t('common-verify-flow.starter-success-no-limit'),
					},
					{
						left: this.$t('common-verify-flow.b9'),
						right: this.$t('common-verify-flow.starter-success-no-limit'),
					},
				],
				level2: [
					this.$t('common-verify-flow.b6-1'),
					this.$t('common-verify-flow.b15'),
					`${this.$t('common-verify-flow.b7')} ${this.kyc24_withdrawal_limit_high} ${
						this.kyc24_withdrawal_limit_high_coin
					} ${this.$t('common-verify-flow.daily')}`,
					this.$t('common-verify-flow.b11'),
					this.$t('common-verify-flow.b8'),
					this.$t('common-verify-flow.b12'),
					this.$t('common-verify-flow.b9'),
					this.$t('common-verify-flow.b14'),
					this.$t('common-verify-flow.b10'),
					this.$t('common-verify-flow.b16'),
				],
			};
		},
	},
	methods: {
		async getKYCWithdrawalLimitData() {
			const resData = await axiosClient({
				method: 'GET',
				url: '/gw-api/asset/withdraw/cert/limit',
			});

			if (!resData?.success) return;

			this.kyc24_withdrawal_limit_low = resData.data.quotaKyc1
				? resData.data.quotaKyc1
				: this.kyc24_withdrawal_limit_low;
			this.kyc24_withdrawal_limit_high = resData.data.quotaKyc2
				? resData.data.quotaKyc2
				: this.kyc24_withdrawal_limit_high;
			this.kyc24_withdrawal_limit_low_coin = resData.data.defaultCoinKyc1
				? resData.data.defaultCoinKyc1
				: this.kyc24_withdrawal_limit_low_coin;
			this.kyc24_withdrawal_limit_high_coin = resData.data.defaultCoinKyc2
				? resData.data.defaultCoinKyc2
				: this.kyc24_withdrawal_limit_high_coin;
		},
		goDeposit() {
			this.$emit('cancel');
			// console.log('varifyFlow > goDeposit', this.$route.name);
			if (this.$route.name !== 'asset-spot-lang' && this.$route.name !== 'buy-sell-lang') {
				this.$store.commit('SHOW_DEPOSIT_GUID');
			}
		},
		handleNext() {
			this.$emit('next');
		},
	},

	mounted() {
		this.getKYCWithdrawalLimitData();
	},
};
</script>
<style lang="less">
.day-mode {
	--comp-verify-flow-dialog-result-color-text: #1a1b1f;
	--comp-verify-flow-dialog-result-color-text-400: #86939b;
	--comp-verify-flow-dialog-result-color-bd: #eeeeee;
	--comp-verify-flow-dialog-result-color-bg: #fff;
}

.night-mode {
	--comp-verify-flow-dialog-result-color-text: #ffffff;
	--comp-verify-flow-dialog-result-color-text-400: #9cb3ba;
	--comp-verify-flow-dialog-result-color-bd: #9cb3ba66;
	--comp-verify-flow-dialog-result-color-bg: #2a2d37;
}
</style>
<style lang="less" module>
@import '~/common/css/element-base-type.less';

.VF {
	background-color: var(--comp-verify-flow-dialog-result-color-bg, #fff);
	width: 100%;

	&__Wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
		box-sizing: border-box;
		padding: 0px 80px;
	}
	&__Advance {
		width: 100%;
		margin-top: 60px;

		& > div {
			font-style: normal;
			font-weight: normal;
			font-size: 12px;
			line-height: 16px;
			color: var(--comp-verify-flow-dialog-result-color-text-400, #86939b);
			span {
				color: #13c2c2;
			}
		}

		&--popover {
			padding: 16px 20px;
			background-color: var(--comp-verify-flow-dialog-result-color-bg, #fff);
			border-color: var(--comp-verify-flow-dialog-result-color-bg, #fff);

			.VF__Cando {
				margin-top: 0;
			}

			:global {
				.el-popover__title {
					font-style: normal;
					font-weight: bold;
					font-size: 16px;
					color: var(--comp-verify-flow-dialog-result-color-text, #1a1b1f);
					margin-bottom: 24px;
				}
			}
		}
	}
	&__SubmitBtn {
		flex: 1;
		width: 480px;
		height: 48px;
		text-align: center;
		font-size: 14px;
		line-height: 48px;
		color: #fff;
		background-color: @blue-base;
		border-radius: 8px;
		font-weight: 500;
		cursor: pointer;
		margin-top: 18px;
	}
	&__nextStep {
		margin-top: 16px;
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		color: @blue-base;
		cursor: pointer;
		user-select: none;
	}
	&__Complete {
		display: flex;
		flex-direction: column;
		align-items: center;

		i {
			font-size: 52px;
			color: #52c41a;
		}

		p {
			margin-top: 19px;
			font-style: normal;
			font-weight: 500;
			font-size: 20px;
			color: var(--comp-verify-flow-dialog-result-color-text, #1a1b1f);
		}
	}
	&__Cando {
		width: 100%;
		margin-top: 45px;
		&--item {
			margin-bottom: 12px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 1px dashed var(--comp-verify-flow-dialog-result-color-bd, #eeeeee);
			padding-bottom: 14px;

			&:last-child {
				border-bottom: 0;
				margin-bottom: 0;
			}

			&--left {
				img {
					margin-right: 16px;
				}
			}
			&--right {
				font-style: normal;
				font-weight: 500;
				font-size: 12px;
				text-align: right;
				color: var(--comp-verify-flow-dialog-result-color-text, #1a1b1f);
			}
			span {
				color: var(--comp-verify-flow-dialog-result-color-text, #1a1b1f);
				font-size: 14px;
			}
		}
	}
}

@media (max-width: 768px) {
	.VF {
		&__Wrapper {
			width: 100%;
			padding: 0px 20px;
		}
		&__SubmitBtn {
			width: 100%;
		}
		&__Cando {
			margin-top: 60px;
		}
		&__Complete {
			i {
				font-size: 33px;
			}
		}
	}
}
</style>
